import React, { useEffect, useState } from 'react';

function diff(target) {
  const total = Math.max(0, target - Date.now());
  return {
    days: Math.floor(total / 86400000),
    hrs: Math.floor((total / 3600000) % 24),
    min: Math.floor((total / 60000) % 60),
    sec: Math.floor((total / 1000) % 60),
  };
}

// Counts down to the race end timestamp supplied by the leaderboard API.
export default function Countdown({ end }) {
  const target = new Date(end).getTime();
  const [t, setT] = useState(() => diff(target));

  useEffect(() => {
    setT(diff(target));
    const id = setInterval(() => setT(diff(target)), 1000);
    return () => clearInterval(id);
  }, [target]);

  const units = [['DAYS', t.days], ['HRS', t.hrs], ['MIN', t.min], ['SEC', t.sec]];

  return (
    <div className="flex items-center gap-1.5 sm:gap-3" data-testid="race-countdown" role="timer" aria-label={`${t.days} days ${t.hrs} hours ${t.min} minutes remaining`}>
      {units.map(([label, v], i) => (
        <React.Fragment key={label}>
          <div className="flex flex-col items-center" aria-hidden="true">
            <div className="ar-panel flex items-center justify-center font-display font-bold text-cyan w-[54px] h-[54px] text-2xl sm:w-[68px] sm:h-[68px] sm:text-3xl tabular-nums">
              {String(v).padStart(2, '0')}
            </div>
            <span className="mt-2 text-[9px] sm:text-[10px] tracking-[0.2em] text-muted font-tech font-semibold">{label}</span>
          </div>
          {i < units.length - 1 && <span className="text-cyan text-xl sm:text-2xl font-display -mt-5" aria-hidden="true">:</span>}
        </React.Fragment>
      ))}
    </div>
  );
}
